import { FunctionComponent } from 'react';

import RewindIcon from '@/components/icons/Rewind';
import SbsIcon from '@/components/icons/SBS';

interface RewindWatermarkProps {
  className?: string;
}

const RewindWatermark: FunctionComponent<RewindWatermarkProps> = (props) => {
  const { className } = props;

  return (
    <div className={className}>
      <div
        className="flex flex-col items-center justify-center
          w-[102px] h-[62px] md:w-[160px] md:h-[96px] bg-black-pearl rounded-tl-[84px]
          pl-[20px]"
        aria-label="SBS Rewind"
        title="SBS Rewind"
      >
        <div>
          <SbsIcon className="h-[12px] md:h-[20px]"/>
        </div>
        <div className="mt-[10px]">
          <RewindIcon className="h-[12px] md:h-[20px]"/>
        </div>
      </div>
    </div>
  );
};

export default RewindWatermark;
